import { Outlet } from 'react-router-dom';
import { SoftwallProvider } from './SoftWall';
import Layout from '../../components/Layout/Layout';
import { setSessionUser } from '../../Reducers/actions/authActions';
import { supabase } from '../../../supabase';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import useSessionProfile from '../../../hooks/useSessionProfile';

export default function SoftwallLayout() {
    const dispatch = useDispatch();
    const fetchUserProfile = useSessionProfile();
    useEffect(() => {
        const initializeSession = async () => {

          try {
            const { data } = await supabase.auth.getSession();
            if (data?.session) {
              // setSession(data.session);
              dispatch(setSessionUser(data.session));
              fetchUserProfile(data.session?.user?.id);
            }
          } catch (error) {
            console.error("Error fetching session:", error);
          }
        };

        initializeSession();

        const { data: listener } = supabase.auth.onAuthStateChange(async (event, newSession) => {
          if (event !== "INITIAL_SESSION" && newSession?.user?.id) {
            fetchUserProfile(newSession.user.id);
          }

          if (!newSession) {
            setTimeout(() => {
              dispatch(setSessionUser(newSession));
            }, 3000)
          } else {
            // setSessionUser(newSession)
            dispatch(setSessionUser(newSession));
          }

        });

        return () => {
          listener?.subscription?.unsubscribe();
        };
      }, [dispatch, fetchUserProfile]);
    return (
        <SoftwallProvider>
            <Layout />
        </SoftwallProvider>
    );
}
